<div class="row g-0">
  <div
    class="col-auto d-flex flex-row align-items-center box__one mb-3 ps-2 pe-3 py-2 rounded-3"
    (click)="onClick()"
  >
    <mat-icon>{{ icon }}</mat-icon>
    <div
      class="text__one"
      (click)="onClick()"
      [class]="lang.isRTL ? 'rtl-text__one' : ''"
    >
      {{ label }}
    </div>
  </div>
</div>
